
import { isEmpty } from "lodash";
import ReadAxios from "../../components/axiosComponent/read";
import * as types from '../types/permissionsType';
import * as axios from "axios";

export const permissionType = (permission) => {
    return {
        type: types.IS_PERMISSION,
        permission,
    };
};

export function permissions(role, token) {
    return (dispatch) => {
        let payload = {role:role, 'customerNumber': `${localStorage.getItem("customerNumber")}`, 'userId':`${localStorage.getItem("userId")}`}
        return axios
        .post(`${process.env.REACT_APP_MASTER_API}/permission?module_name=transporter_allocation`, payload, {
          headers: { Authorization: token,'content-type': 'application/json', },
        })
            .then((response) => {
                if (!isEmpty(response.data.permissions)) {
                    dispatch(permissionType(response.data.permissions));
                    return new Promise(function (resolve) {
                        resolve(response.data.permissions);
                    });
                }
            })
            .catch((err) => {
                return err;
            });
    };
}